import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/dusty.gif'


const _hoisted_1 = { class: "hello" }
const _hoisted_2 = { class: "homeCards" }

import Card from 'primevue/card';
import 'primeicons/primeicons.css';

const __default__ = {
  name: "HomePage",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[10] || (_cache[10] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("img", {
        class: "hero-logo",
        src: _imports_0,
        alt: "Dusty, the Berkstresser LLC dust bunny mascot"
      }),
      _createElementVNode("h1", null, "Berkstresser LLC Learning"),
      _createElementVNode("p", { class: "hero-tagline" }, "Providing a quality, personalized education to those who are academically able but inadequately served by the public school system"),
      _createElementVNode("a", {
        class: "cta-button",
        href: "https://www.facebook.com/BerkstresserLLC",
        target: "_blank",
        rel: "noopener"
      }, "Contact Us")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card), { class: "homeCard" }, {
          header: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "pi pi-compass card-icon",
              "aria-hidden": "true"
            }, null, -1)
          ])),
          title: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Mission")
          ])),
          subtitle: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Providing a quality, personalized education to those who are academically able but inadequately served by the public school system")
          ])),
          content: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("p", null, " Motivated students, no matter what age or subject, should have their chance at excellence. We can help. ", -1)
          ])),
          _: 1
        }),
        _createVNode(_unref(Card), { class: "homeCard" }, {
          header: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("i", {
              class: "pi pi-users card-icon",
              "aria-hidden": "true"
            }, null, -1)
          ])),
          title: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("About Us")
          ])),
          content: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("p", null, "Berkstresser Learning is a home-based tutoring service with:", -1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "A holistic approach to education"),
              _createElementVNode("li", null, "A secular worldview"),
              _createElementVNode("li", null, "A passion for teaching students who want to learn"),
              _createElementVNode("li", null, "A passion for learning new things ourselves"),
              _createElementVNode("li", null, "Over 35 years of combined education experience"),
              _createElementVNode("li", null, "Grade levels & Subjects: K-12 in core subjects, English Language Learners, Lower college levels"),
              _createElementVNode("li", null, "Flexible scheduling"),
              _createElementVNode("li", null, "Virtual tutoring available when the subject and grade level allow"),
              _createElementVNode("li", null, "Virtual tutoring via Zoom unless otherwise arranged")
            ], -1)
          ])),
          _: 1
        }),
        _createVNode(_unref(Card), { class: "homeCard" }, {
          header: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("i", {
              class: "pi pi-phone card-icon",
              "aria-hidden": "true"
            }, null, -1)
          ])),
          title: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("Contact Us")
          ])),
          content: _withCtx(() => _cache[9] || (_cache[9] = [
            _createElementVNode("p", null, [
              _createTextVNode(" Visit us on "),
              _createElementVNode("a", {
                target: "_blank",
                rel: "noopener",
                href: "https://www.facebook.com/BerkstresserLLC"
              }, "Facebook"),
              _createElementVNode("br")
            ], -1),
            _createTextVNode(" To reach tutors individually: "),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createTextVNode("CJ Berkstresser (owner) - K-12 Math, ELA, Science, History "),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "tel:417-929-2533" }, "417-929-2533")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "mailto:cjberkstresser@gmail.com" }, "cjberkstresser@gmail.com")
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createTextVNode("Kendell Loyd - HS Biology, College Biology, Can communicate through ASL "),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "tel:583-776-0901" }, "583-776-0901")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "mailto:kloyd892@gmail.com" }, "kloyd892@gmail.com")
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createTextVNode("Caleb Berkstresser - HS-College Mathematics, Computer Science, English "),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "tel:417-929-2719" }, "417-929-2719")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "mailto:cdberkstresser@protonmail.com" }, "cdberkstresser@protonmail.com")
                  ])
                ])
              ])
            ], -1),
            _createTextVNode(" Located in Springfield & Willard, MO, but willing to Zoom anywhere! ")
          ])),
          _: 1
        })
      ])
    ])
  ]))
}
}

})